// extracted by mini-css-extract-plugin
export var actionButton = "_8x-0";
export var attachmentLine = "_8x-1";
export var fileInput = "_8x-2";
export var fileUploadWrapper = "_8x-4";
export var footer = "_8x-3";
export var modalContent = "_8x-5";
export var paperclip = "_8x-6";
export var quillEditor = "_8x-7";